(function() {
    'use strict';

    angular.module('directives.highlightOverlay', [])
        .directive('highlightOverlay', directive);

    directive.$inject = [];

    function directive() {
        return {
            restrict: 'A',
            templateUrl: require('./highlightOverlay.tpl.html'),
            transclude: true,
            controller: ['$rootScope', '$scope', function ($rootScope, $scope) {
                $scope.showDimOverlay = false;
            }],
            link: function (scope, elem, attr) {
                var higlightContent = angular.element(elem[0].querySelector('.highlight-content'));

                elem.on('click', '.highlight-content', function (e) {
                    higlightContent[0].classList.add('highlight');
                    scope.$apply(function () {
                        scope.showDimOverlay = !scope.showDimOverlay;
                    })
                });

                elem.on('click', '.dim-overlay', function (e) {
                    higlightContent[0].classList.remove('highlight');
                    scope.$apply(function () {
                        scope.showDimOverlay = !scope.showDimOverlay;
                    })
                });
            },
        };
    }
})();